import { useState, useCallback } from 'react';

const EDITING_FIELDS = {
    STATUS: 'status',
    PRIORITY: 'priority',
    TYPE: 'type',
    COORDINATOR: 'coordinator',
    SERVICEMAN: 'serviceman',
    WORKING_TIME: 'workingTime',
    DIFFICULTY: 'difficulty',
    DESCRIPTION: 'description',
    SERVICE_NOTE: 'serviceNote',
    PLANNED_DATE: 'plannedDate',
    USED_PARTS: 'usedParts',
    CONTRACTOR_NAME_GROUP: 'contractorNameGroup',
    CONFIG_GROUP: 'configGroup',
};

export const useEditingStates = () => {
    const [currentEditingField, setCurrentEditingField] = useState(EDITING_FIELDS.STATUS);

    const startEditing = useCallback(field => {
        setCurrentEditingField(field);
    }, []);

    const stopEditing = useCallback(() => {
        setCurrentEditingField(null);
    }, []);

    const setDefaultEditingStatus = useCallback(() => {
        setCurrentEditingField(EDITING_FIELDS.STATUS);
    }, []);

    const isEditing = useCallback(
        field => {
            return currentEditingField === field;
        },
        [currentEditingField],
    );

    const startEditingStatus = useCallback(() => startEditing(EDITING_FIELDS.STATUS), [startEditing]);
    const startEditingPriority = useCallback(() => startEditing(EDITING_FIELDS.PRIORITY), [startEditing]);
    const startEditingType = useCallback(() => startEditing(EDITING_FIELDS.TYPE), [startEditing]);
    const startEditingCoordinator = useCallback(() => startEditing(EDITING_FIELDS.COORDINATOR), [startEditing]);
    const startEditingServiceman = useCallback(() => startEditing(EDITING_FIELDS.SERVICEMAN), [startEditing]);
    const startEditingWorkingTime = useCallback(() => startEditing(EDITING_FIELDS.WORKING_TIME), [startEditing]);
    const startEditingDifficulty = useCallback(() => startEditing(EDITING_FIELDS.DIFFICULTY), [startEditing]);
    const startEditingDescription = useCallback(() => startEditing(EDITING_FIELDS.DESCRIPTION), [startEditing]);
    const startEditingServiceNote = useCallback(() => startEditing(EDITING_FIELDS.SERVICE_NOTE), [startEditing]);
    const startEditingPlannedDate = useCallback(() => startEditing(EDITING_FIELDS.PLANNED_DATE), [startEditing]);
    const startEditingUsedParts = useCallback(() => startEditing(EDITING_FIELDS.USED_PARTS), [startEditing]);
    const startEditingContractorNameGroup = useCallback(() => startEditing(EDITING_FIELDS.CONTRACTOR_NAME_GROUP), [startEditing]);
    const startEditingConfigGroup = useCallback(() => startEditing(EDITING_FIELDS.CONFIG_GROUP), [startEditing]);
    return {
        currentEditingField,
        startEditing,
        stopEditing,
        isEditing,
        startEditingStatus,
        startEditingPriority,
        startEditingType,
        startEditingCoordinator,
        startEditingServiceman,
        startEditingWorkingTime,
        startEditingDifficulty,
        startEditingDescription,
        startEditingServiceNote,
        startEditingPlannedDate,
        startEditingUsedParts,
        startEditingContractorNameGroup,
        startEditingConfigGroup,
        resetAllEditingStates: stopEditing,
        FIELDS: EDITING_FIELDS,
        setDefaultEditingStatus,
    };
};
